import { render } from "./SkeletonServicesListMobile.vue?vue&type=template&id=7ed651e8&scoped=true"
import script from "./SkeletonServicesListMobile.vue?vue&type=script&lang=js"
export * from "./SkeletonServicesListMobile.vue?vue&type=script&lang=js"

import "./SkeletonServicesListMobile.vue?vue&type=style&index=0&id=7ed651e8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7ed651e8"
/* hot reload */
if (module.hot) {
  script.__hmrId = "7ed651e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ed651e8', script)) {
    api.reload('7ed651e8', script)
  }
  
  module.hot.accept("./SkeletonServicesListMobile.vue?vue&type=template&id=7ed651e8&scoped=true", () => {
    api.rerender('7ed651e8', render)
  })

}

script.__file = "src/ui/skeleton/services/SkeletonServicesListMobile.vue"

export default script